export const faq = {
  badge: "FAQ",
  title: "Veelgestelde vragen",
  subtitle: "Alles wat je moet weten over DONKEY TRAVEL",
  items: {
    q1: {
      question: "Hoe werkt het Uitwisseling-systeem?",
      answer:
        "Het is een directe ruil tussen twee eigenaars. Je wordt het eens over de data (gelijktijdig of uitgesteld) en de voorwaarden. Geen punten, geen ingewikkelde berekeningen, gewoon menselijk.",
    },
    q2: {
      question: "Moet ik tegelijkertijd ruilen?",
      answer:
        "Nee! Dat is het hele punt van ons flexibele systeem. Je kunt Jean in april ontvangen en in oktober bij hem langsgaan. Dit maakt het ook mogelijk om elkaar te ontmoeten bij de sleuteloverdracht!",
    },
    q3: {
      question: "Hoe worden leden geverifieerd?",
      answer:
        "Alle leden moeten geverifieerde Airbnb-hosts zijn. We verifiëren ook de identiteit, de woning en de Airbnb-beoordelingen van elk lid om de veiligheid van de gemeenschap te garanderen.",
    },
    q4: {
      question: "Wat gebeurt er bij problemen?",
      answer:
        "Ons supportteam is 7/7 beschikbaar om je te begeleiden. Bovendien helpt ons beoordelings- en scoresysteem om een vertrouwde gemeenschap te behouden en problemen snel op te lossen.",
    },
    q5: {
      question: "Zijn er verborgen kosten?",
      answer:
        "Nee, geen verborgen kosten. Je betaalt alleen je jaarabonnement afhankelijk van de gekozen geografische zone. De ruilen zijn daarna volledig gratis, zonder commissie of extra kosten.",
    },
    q6: {
      question: "Kan ik kiezen wie er bij mij verblijft?",
      answer:
        "Absoluut! Je hebt de volledige controle. Je kunt profielen bekijken, beoordelingen lezen en elk ruilverzoek accepteren of weigeren op basis van je voorkeuren.",
    },
    q7: {
      question: "Is mijn woning verzekerd tijdens de ruil?",
      answer:
        "Ja, alle uitwisselingen zijn gedekt door onze partnerverzekering. Daarnaast raden we aan om je eigen woningverzekering te checken voor optimale bescherming.",
    },
    q8: {
      question: "Hoe ver van tevoren moet ik reserveren?",
      answer:
        "Dat hangt van elke eigenaar af. Sommigen accepteren last-minute boekingen, anderen plannen liever maanden vooruit. We raden aan om minstens 2-3 weken van tevoren te reserveren.",
    },
  },
  cta: {
    title: "Heb je nog andere vragen?",
    subtitle:
      "Ons team staat klaar om je te helpen bij het starten van je TRAVELTROK-avontuur",
    button: "Neem contact met ons op",
  },
};
